<ng-container *ngIf="!editableMapItem; else mapSettings">
    <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>

    <div class="panel-options-body overflow-wrapper" *ngrxLet="isUser$ as isUser">
        <p class="text-muted mb-20" *ngIf="isUser">
            {{ "maps_api_key_help_text" | translate }}.<br />
            <a href="{{ 'api_key_setup_help_link' | translate }}" target="_blank"
                >{{ "api_key_setup_help" | translate }}
                <img class="font-icon" src="./assets/img/websites/lpc-new-window-icon.svg"
            /></a>
        </p>

        <div class="form form-horizontal">
            <div class="form-row mb-20" *ngIf="isUser">
                <div class="form-group">
                    <label class="col-xs-12">{{ "input_maps_api_key" | translate }}</label>
                    <div class="col-xs-12" *ngrxLet="mapsApiKey$ as mapsApiKey">
                        <input
                            #apiKeyInput
                            type="text"
                            class="form-control"
                            [class.disabled]="mapsApiKey && !apiKeyEditing"
                            [value]="mapsApiKey"
                            [minLength]="30"
                            [maxLength]="40"
                            [cdkTrapFocus]="apiKeyEditing"
                            [cdkTrapFocusAutoCapture]="apiKeyEditing"
                            (blur)="setApiKey($event.target.value)"
                        />
                        <div class="fast-links help-block">
                            <a *ngIf="mapsApiKey && !apiKeyEditing" class="dashed" (click)="editApiKey()">{{
                                "edit" | translate
                            }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-20">
                <div *ngFor="let mapItem of addresses.value; let i = index">
                    <sp-control-handle
                        [controlHandleDisableDelete]="disabledLastDeleteBtn"
                        [controlHandleMainText]="mapItem.address"
                        [controlHandleSubText]="mapItem.title"
                        (editActionEvent)="editMapItem(mapItem, i)"
                        (removeActionEvent)="removeMapItem(i)"
                    >
                    </sp-control-handle>
                </div>
                <a class="dotted" (click)="addMapItem()">{{ "add_maps_address" | translate }}</a>
            </div>

            <div class="form-row mb-20">
                <div class="form-group">
                    <label class="col-xs-4 control-label"> {{ "maps_scale" | translate }} </label>
                    <div class="col-xs-5">
                        <sp-slider
                            [options]="sliderOptions"
                            [value]="zoom.value"
                            (valueChangeEvent)="setZoomSlider($event)"
                        ></sp-slider>
                    </div>
                    <div class="col-xs-3">
                        <sp-input-num
                            [min]="minMapZoom"
                            [max]="maxMapZoom"
                            [value]="zoom.value"
                            (valueChange)="setZoom($event)"
                        >
                        </sp-input-num>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="col-xs-12">{{ "maps_style" | translate }}</label>
                    <div class="col-xs-12 map-style-presets">
                        <div
                            *ngFor="let styleItem of mapStyleList"
                            [ngClass]="{ active: styleItem === widgetData.mapStyle }"
                            (click)="setMapStyle(styleItem)"
                            class="preset-btn"
                        >
                            <img src="./assets/img/websites/map-themes/{{ styleItem }}-map-thumbnail.png" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-20">
                <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)">
                </web-custom-id>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #mapSettings>
    <web-map-settings
        [item]="editableMapItem"
        [mapStyle]="widgetData.mapStyle"
        [widgetId]="widget.id"
        (saveEvent)="saveMapItem($event)"
        (cancelEvent)="editMapItem(null, null)"
    ></web-map-settings>
</ng-template>
